import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=8d333d4a&scoped=true&"
import script from "./contract.vue?vue&type=script&lang=js&"
export * from "./contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d333d4a",
  null
  
)

export default component.exports